import InputField from "../../../../../common/InputField";
import React from "react";

const LocationDetails = () => {
    return(
        <div className="basic-details-wrapper">
            <h3>Company Address</h3>
            <InputField
                name={['company', 'addressLine1']}
                label={'Address line 1'}
                isDisabled={true}
            />
            <InputField
                name={['company', 'addressLine2']}
                label={'Address line 2'}
                isDisabled={true}
            />
            <InputField
                name={['company', 'postalCode']}
                label={'Postal Code'}
                isDisabled={true}
            />
            <InputField
                name={['company', 'city']}
                label={'City'}
                isDisabled={true}
            />
            <InputField
                name={['company', 'country']}
                label={'Country'}
                isDisabled={true}
            />

        </div>
    );
};

export default LocationDetails;